import { useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { useHotKeys, useQuery } from 'Hooks'
import { ResizableBox } from 'react-resizable'
import { MoreVertical } from 'react-feather'
import { connect } from 'react-redux'
import LeftPanel from './LeftPanel'
import RightPanel from './RightPanel'
import './index.scss'
import 'react-resizable/css/styles.css'
import { SearchModal, WelcomeMessage } from 'Components'
import { toggleSearchModal } from 'Actions/explore'
import { setCurrentBranch } from 'Actions/branches'
import WeaverService from 'Services/WeaverService'


Explore = ({ width, height, searchModalVisible, toggleSearchModal, currentBranch, branches, setCurrentBranch }) ->
  defaultWidth = parseInt(localStorage.getItem('treeNavWidth')) or Math.max(window.innerWidth / 3.5, 400)

  [fullW, setFullW] = useState(width) # side bar width = 54
  [fullH, setFullH] = useState(height)
  [treeNavWidth, setTreeNavWidth] = useState(defaultWidth)
  [leftPanelCollapsed, setLeftPanelCollapsed] = useState(false)
  [showCollapserHelper, setShowCollapserHelper] = useState(false)
  [showExpanderHelper, setShowExpanderHelper] = useState(false)
  [welcomeMessageVisible, setWelcomeMessageVisible] = useState(JSON.parse(localStorage.getItem('newUser')))

  { url } = useRouteMatch()
  { hash }  = useLocation()
  params = useQuery()
  history = useHistory()

  useEffect( ->
    if not params.get('branch')
      params.set('branch', currentBranch or 'main')
      history.replace({ pathname: url, search: params.toString(), hash })
    branch = params.get('branch')
    if branches.find((b) -> b.id() is branch)? and currentBranch isnt branch
      setCurrentBranch(branch)
      Weaver.getInstance().useBranch(branches.find((b) -> b.id() is branch))
    undefined
  , [params])

  useEffect( ->
    setFullW(width)
    setFullH(height)
  , [width, height])

  expand = ->
    setLeftPanelCollapsed(false)
    setTreeNavWidth(305)
    setShowExpanderHelper(false)

  collapse = ->
    setLeftPanelCollapsed(true)
    setTreeNavWidth(0)
    setShowCollapserHelper(false)

  toggleLeftPanel = ->
    if leftPanelCollapsed
      expand()
    else
      collapse()

  toggleSearch = ->
    toggleSearchModal(not searchModalVisible)

  useHotKeys([{
    sequence: 'o'
    fn: toggleLeftPanel
    watchers: [leftPanelCollapsed]
  }])

  useHotKeys([{
    sequence: 'mod+k'
    fn: toggleSearch
    watchers: [searchModalVisible]
  }])

  <div style={{ display: 'flex', flexFlow: 'row nowrap' }}>
    <SearchModal visible={searchModalVisible} onClose={ -> toggleSearch(false)} />
    <WelcomeMessage
      visible={welcomeMessageVisible}
      setVisible={setWelcomeMessageVisible}
    />
    <div className="collapser-helper #{ if showCollapserHelper then 'active' } #{ if showExpanderHelper then 'wide' }" />
    {if leftPanelCollapsed
      <div
        style={{
          left:0,
          position: 'relative'
          marginRight: -23
        }}
        className="resizer-handle"
        draggable={true}
        onDrag={(e) ->
          setShowCollapserHelper(true)
          if e.clientX > 135
            setShowExpanderHelper(true)
          else
            setShowExpanderHelper(false)
        }
        onDragEnd={(e) ->
          setShowCollapserHelper(false)
          if e.clientX > 135
            expand()
        }
        onDoubleClick={expand}
      >
        <MoreVertical />
      </div>
    else
      <ResizableBox
        height={fullH}
        width={treeNavWidth}
        minConstraints={[200, fullH]}
        maxConstraints={[fullW, fullH]}
        onResize={(event, { size }) ->
          setTreeNavWidth(size.width)
          if size.width < 205
            setShowCollapserHelper(true)
          else
            setShowCollapserHelper(false)
          localStorage.setItem('treeNavWidth', size.width)
        }
        onResizeStop={ ->
          if showCollapserHelper
            collapse()
        }
        handle={
          <div
            style={{
              left: treeNavWidth,
              position: 'absolute'
            }}
            className="resizer-handle"
            onDoubleClick={collapse}
          >
            <MoreVertical />
          </div>
        }
        className="left-panel"
      >
        <LeftPanel width={treeNavWidth} />
      </ResizableBox>
    }
      <div style={{
        width: fullW - treeNavWidth,
        height: '100%',
        zIndex: 1
      }}>
        <RightPanel left={treeNavWidth + 63} />
      </div>
    </div>

mapStateToProps = ({
  branches: { branches, currentBranch }
  explore: { width, height, searchModalVisible }
}) ->
  { width, height, searchModalVisible, branches, currentBranch }

export default withRouter(connect(
  mapStateToProps,
  { toggleSearchModal, setCurrentBranch }
)(Explore))
